var heading_default = {
  "fontElementMap": "cFGuG",
  "elementSpacing": "_3z5wP",
  "headerOne": "tfmO9 _3z5wP",
  "headerTwo": "Xni8y _3z5wP",
  "headerThree": "r5d-P _3z5wP",
  "headerFour": "d337t _3z5wP",
  "headerFive": "Zu6RH _3z5wP",
  "headerSix": "MQChk _3z5wP",
  "child": "kdaK-"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
